import React from "react";
import tw from "twin.macro";

import "./Style.css";

export default () => {
  return (
    <div class="testimonial-body">
      <h1 class="testimonial-title">Our Client Testimonials</h1>
      <div class="outerdiv">
        <div class="innerdiv">
          <div class="div1 eachdiv">
            <div class="userdetails">
              <div class="imgbox">
                <img
                  src="https://raw.githubusercontent.com/RahulSahOfficial/testimonials_grid_section/5532c958b7d3c9b910a216b198fdd21c73112d84/images/image-daniel.jpg"
                  alt=""
                />
              </div>
              <div class="detbox">
                <p class="name">Daniel Clifford</p>
                <p class="designation">Verified Graduate</p>
              </div>
            </div>
            <div class="review">
              <h4>
                We had a great experience with Singh Drywall. From the moment I contacted Gagan, he was prompt to respond and very professional.
              </h4>
              <p>
                “ We had our ceiling repaired after some water damage. Todd did the drywall and painting. I was so impressed how punctual and professional he was. He cleaned up at the end of everyday. The final results were flawless.

                We had an extremely good experience and look forward to using them in the future. <br /> <br />
                Overall, great experience dealing with Gagan and his team. Happy with the completed work.
                ”
              </p>
            </div>
          </div>
          <div class="div2 eachdiv">
            <div class="userdetails">
              <div class="imgbox">
                <img
                  src="https://raw.githubusercontent.com/RahulSahOfficial/testimonials_grid_section/5532c958b7d3c9b910a216b198fdd21c73112d84/images/image-jonathan.jpg"
                  alt=""
                />
              </div>
              <div class="detbox">
                <p class="name">Jonathan Walters</p>
                <p class="designation">Verified Graduate</p>
              </div>
            </div>
            <div class="review">
              <h4>Excellent communication and work done</h4>

              <p>
                “Singh Drywall removed the popcorn ceiling in my condo.
                They did a tremendous job. We had a tight timeframe and a lot to accomplish including paint and door replacements.
                Gagan's team was fast, efficient and fairly priced.”
              </p>
            </div>
          </div>
          <div class="div3 eachdiv">
            <div class="userdetails">
              <div class="imgbox">
                <img
                  src="https://raw.githubusercontent.com/RahulSahOfficial/testimonials_grid_section/5532c958b7d3c9b910a216b198fdd21c73112d84/images/image-kira.jpg"
                  alt=""
                />
              </div>
              <div class="detbox">
                <p class="name dark">Kira Whittle</p>
                <p class="designation dark">Verified Graduate</p>
              </div>
            </div>
            <div class="review dark">
              <h4>We had the pleasure of Singh Drywall paint and repair our water damaged ceiling</h4>
              <p>
                “ Singh Drywall recently completed excellent quality work in my condo. My ceiling needed major repair work with the difficult task of matching and blending the
                textured ceiling, as well as painting it. They did an amazing job! It looks brand new. I highly recommend this company, not only for their outstanding workmanship,
                level of professionalism and attention to detail; but even more importantly,
                for their very sincere care and kindness in their customer service from the very beginning to the end of the job.
                Graciousness in the trades is hard to come by in my experience. This company will not rush, or cut corners.
                They give sound advice and use quality products for a fair price.
                I am grateful to have found this company.  ”
              </p>
            </div>
          </div>
          <div class="div4 eachdiv">
            <div class="userdetails">
              <div class="imgbox">
                <img
                  src="https://raw.githubusercontent.com/RahulSahOfficial/testimonials_grid_section/5532c958b7d3c9b910a216b198fdd21c73112d84/images/image-jeanette.jpg"
                  alt=""
                />
              </div>
              <div class="detbox">
                <p class="name dark">Jeanette Harmon</p>
                <p class="designation dark">Verified Graduate</p>
              </div>
            </div>
            <div class="review dark">
              <h4>An overall wonderful and rewarding experience</h4>
              <p>
                “ Thank you for the wonderful experience! I now have a job I
                really enjoy, and make a good living while doing something I
                love. ”
              </p>
            </div>
          </div>
          <div class="div5 eachdiv">
            <div class="userdetails">
              <div class="imgbox">
                <img
                  src="https://raw.githubusercontent.com/RahulSahOfficial/testimonials_grid_section/5532c958b7d3c9b910a216b198fdd21c73112d84/images/image-patrick.jpg"
                  alt=""
                />
              </div>
              <div class="detbox">
                <p class="name">Patrick Abrams</p>
                <p class="designation">Loffredo Brooks Architects</p>
              </div>
            </div>
            <div class="review">
              <h4>
                Fantastic experience and wonderful professionalism. Worth every penny and I highly recommend them
              </h4>
              <p>
                "I had my ceiling repaired and painted. Very happy with the whole experience. Contacting Shawn and getting the quote was fast and efficient. The crew arrived right on time and finished with a good clean up. I was so impressed with the quality of their work. I highly recommend Gagan Drywall and Painting and I have already told my friends to give them a call."
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
